import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="xl-footer">
      <p>杭州序列深维版权所有@2026</p>
      <p>
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          rel="noopener noreferrer">
          浙ICP备2026009172号-1
        </a>
      </p>
    </footer>
  );
};

export default Footer;